import { render } from "./FloatingForm.vue?vue&type=template&id=642c26ba"
import script from "./FloatingForm.vue?vue&type=script&lang=js"
export * from "./FloatingForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__